<template>
    <section class="app-main">
        <router-view :key="key" />
    </section>
</template>

<script>
export default {
    name: "MasterAppMain",
    computed: {
        key() {
            return this.$route.path;
        },
    },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/layout/master/components/AppMain.vue